import SalesItemResponse from '../interfaces/SalesItemResponse';
import { getCountryCode, getLanguageCode } from '../utils/localization';

import makeFetchClient from './makeFetchClient';

const api = makeFetchClient(window.payorder.SALES_ITEM_CLIENT_ID);

const url = (items: string[]) =>
  `${window.payorder.SALES_ITEM_API_URL}/ru/${getCountryCode()}?itemNos=${items
    .map((itemNo) => itemNo.replace(/\./g, ''))
    .join(',')}&languageCode=${getLanguageCode()}`;

export function getSalesItem(items: string[]) {
  return api.get<SalesItemResponse>(url(items));
}
